document.addEventListener("DOMContentLoaded", function() {
  fetch("https://ipinfo.io/json?token=8857799c51c686")
    .then(response => response.json())
    .then(data => {
      const userRegion = data.region.toLowerCase().replace(/\s+/g, '-');
        const allRegions = [
        "florida-top-picks",
        "connecticuts-top-picks",
        "californias-top-picks",
        "arizonas-top-picks",
        "new-yorks-top-picks",
        "georgias-top-picks",
        "tennessees-top-picks",
        "washingtons-top-picks",
        "north-carolinas-top-picks",
        "texas-top-picks"
      ];

      allRegions.forEach(region => {
        const regionElement = document.getElementById(region);
        if (regionElement) {
          regionElement.style.display = 'none';
        }
      });

      const allProducts = document.getElementById('all-products');
      if (allProducts) {
        allProducts.style.display = 'none';
      }

      const matchedRegion = allRegions.find(region => region.includes(userRegion));
      if (matchedRegion) {
        const regionElement = document.getElementById(matchedRegion);
        if (regionElement) {
          regionElement.style.display = 'block';
        }
      } else {
        if (allProducts) {
          allProducts.style.display = 'block';
        }
      }
    })
    .catch(error => {
      console.error("Error fetching IP information:", error);
      const allProducts = document.getElementById('all-products');
      if (allProducts) {
        allProducts.style.display = 'block';
      }
    });
});